module.exports = __webpack_public_path__ + "img/box2-bg2.803db4c0.png";